// debug-reporter.js
import * as $ from "jquery";

export function DebugReporter(userOptions = {}) {
  const referenceCode =
    "DBG-" +
    Math.random().toString(36).slice(2, 8).toUpperCase() +
    "-" +
    Math.random().toString(36).slice(2, 8).toUpperCase();

  const msg = encodeURIComponent(
    `Dag Wendy & Dennis,\n\n` +
      `Ik krijg een fout bij bestellen.\n` +
      `Referentie: ${referenceCode}\n` +
      `Pagina: ${location.href}\n\n` +
      `Kunnen jullie mij helpen?`,
  );

  const waUrl = `https://wa.me/31620938427?text=${msg}`;
  const mailUrl = `mailto:info@wallable.nl?subject=Hulp bij probleem #${referenceCode}&body=${msg}`;

  const opts = Object.assign(
    {
      // Waar de knop in moet komen
      containerSelector:
        ".js-notifications, .woocommerce-error, .woocommerce-message",

      // Tekst
      buttonText: "Stuur foutrapport naar Wallable",
      sendingText: "Versturen…",
      sentText: `Bedankt! Neem contact met ons op via <a href="${waUrl}"
          target="_blank"
          rel="noopener">Whatsapp</a> of <a href="${mailUrl}"
          target="_blank"
          rel="noopener">E-mail</a>, zodat we je direct kunnen helpen.
      `,
      failedText: "Niet gelukt. Probeer opnieuw.",

      // REST endpoint (WordPress/Woo plugin)
      // Je kunt dit in main.js overschrijven met woocommerceUrl + "/wp-json/..."
      ajaxUrl: "/wp-json/wallable/v1/client-diagnostics",

      // Wanneer knop tonen?
      // meta is wat jij meegeeft via debugReporter.show({ meta: {...}, ... })
      shouldShow: ({ meta, jqXHR, textStatus, errorThrown, messageText }) =>
        true,

      // Extra context toevoegen (optioneel)
      extraContext: () => ({}),

      // Caps
      maxLogs: 200,
      maxResponseText: 4000,
    },
    userOptions,
  );

  // ---------- log buffer ----------
  const buffer = [];

  function push(entry) {
    buffer.push({ ts: new Date().toISOString(), ...entry });
    if (buffer.length > opts.maxLogs) {
      buffer.splice(0, buffer.length - opts.maxLogs);
    }
  }

  function safeSerialize(val) {
    try {
      if (val instanceof Error) {
        return { name: val.name, message: val.message, stack: val.stack };
      }
      return JSON.parse(JSON.stringify(val));
    } catch {
      return String(val);
    }
  }

  // ---------- capture ----------
  function initCapture() {
    // console tee
    ["log", "info", "warn", "error"].forEach((level) => {
      const orig = console[level];
      console[level] = function (...args) {
        push({ type: "console", level, args: args.map(safeSerialize) });
        return orig.apply(console, args);
      };
    });

    // JS runtime errors
    window.addEventListener("error", (e) => {
      push({
        type: "window.error",
        message: e.message,
        filename: e.filename,
        lineno: e.lineno,
        colno: e.colno,
        error: safeSerialize(e.error),
      });
    });

    // Unhandled promise rejections
    window.addEventListener("unhandledrejection", (e) => {
      push({ type: "unhandledrejection", reason: safeSerialize(e.reason) });
    });

    // Global jQuery ajax errors (buffer only; inject button happens via your explicit show())
    $(document).ajaxError((event, jqXHR, settings, thrownError) => {
      push({
        type: "ajaxError",
        url: settings?.url,
        method: settings?.type,
        status: jqXHR?.status,
        statusText: jqXHR?.statusText,
        thrownError: thrownError ? String(thrownError) : null,
        responseText: (jqXHR?.responseText || "").slice(
          0,
          opts.maxResponseText,
        ),
      });
    });
  }

  // ---------- bundle ----------
  function getBundle(extra = {}) {
    return {
      referenceCode,
      page: {
        href: location.href,
        referrer: document.referrer,
        ua: navigator.userAgent,
        lang: navigator.language,
        viewport: { w: window.innerWidth, h: window.innerHeight },
      },
      extra: safeSerialize(extra),
      logs: buffer.slice(),
    };
  }

  // ---------- UI injection ----------
  function findContainer() {
    const $c = $(opts.containerSelector).first();
    return $c.length ? $c : null;
  }

  function maybeInjectButton(meta = {}) {
    if (!opts.shouldShow(meta)) return;

    const $container = findContainer();
    if (!$container) return;

    // voorkom duplicaten
    if ($container.find(".js-debug-report-btn").length) return;

    const $ui = $(`
      <div class="debug-report-ui" style="margin-top:10px;">
        <button type="button" class="btn btn-primary w-100 mb-3 js-debug-report-btn">${opts.buttonText}</button>
        <div class="alert alert-success text-center p-2 d-none js-debug-report-status"></div>
      </div>
    `);

    $container.append($ui);

    $container
      .off("click.debugReport")
      .on("click.debugReport", ".js-debug-report-btn", function () {
        const $btn = $(this);
        const $status = $container.find(".js-debug-report-status");

        $btn.prop("disabled", true);
        $status.text(opts.sendingText);
        $status.removeClass("d-none");

        const payload = getBundle(Object.assign({}, opts.extraContext(), meta));

        $.ajax({
          url: opts.ajaxUrl,
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(payload),
        })
          .done(() => $status.html(opts.sentText))
          .fail((xhr) => {
            $btn.prop("disabled", false);
            $status.text(opts.failedText);
            // optioneel debug:
            console.warn(
              "DebugReporter send failed",
              xhr?.status,
              xhr?.responseText,
            );
          });
      });
  }

  // ---------- public API ----------
  return {
    init() {
      initCapture();
      return this;
    },

    // roep dit aan op jouw “Er ging iets mis…” moment
    show(meta = {}) {
      maybeInjectButton(meta);
    },

    // als je extern een log wil pushen
    log(level, ...args) {
      push({ type: "manual", level, args: args.map(safeSerialize) });
    },

    getBundle,
  };
}
